import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delegate-create-plan1',
  templateUrl: './delegate-create-plan1.component.html',
  styleUrls: ['./delegate-create-plan1.component.scss']
})
export class DelegateCreatePlan1Component implements OnInit {
  sectionTitle = 'Why choose Zenplans'
  delegateCreatePlan1 = {
    title: 'Value proposition 1',
    dataInfo: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
  }
  constructor() { }

  ngOnInit() {
  }

}
